import { createSlice } from '@reduxjs/toolkit';

const notificationSlice = createSlice({
  name: 'notification',
  initialState: {
      notification: null
  },
  reducers: {
    setSuccess(state, action) {
        if (!action || !action.payload || !action.payload) {
            state.notification = null;    
        } else {
            state.notification = {
                message: action.payload,
                status: "success"
            }
        }
    },
    setError(state, action) {
        if (!action || !action.payload || !action.payload) {
            state.notification = null;    
        } else {
            state.notification = {
                message: action.payload,
                status: "error"
            }
        }
    },
    setNotification(state, action) {
      if (!action || !action.payload || !action.payload.message) {
        state.notification = null;    
      } else {
        state.notification = {
            message: action.payload.message,
            status: action.payload.status
        }
      }
    },
    clearNotification(state, action) {
        state.notification = null;
    },
  },
});

export const notificationActions = notificationSlice.actions;

export default notificationSlice;